export default theme => ({
    beerListing: {
        position: 'relative',
        marginBottom: 36,
        paddingTop: 62,
        [theme.breakpoints.up('md')]: {
            paddingTop: 130,
        },
        '& > h2': {
            fontSize: 24,
            letterSpacing: '0.056em',
            lineHeight: 1.25,
            textTransform: 'uppercase',
            color: theme.palette.secondary.contrastText,
            marginBottom: 44,
            marginTop: 0,
            [theme.breakpoints.up('md')]: {
                marginBottom: 80,
                fontSize: 36,
                lineHeight: 1.5,
                letterSpacing: '0.06em',
            },
            '&::before': {
                content: '""',
                width: 40,
                display: 'block',
                borderTop: '4px solid ' + theme.palette.primary.main,
                marginBottom: 20,
            }
        },
        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            backgroundColor: theme.palette.secondary.main,
            top: 0,
            left: '50%',
            width: '100vw',
            height: 230,
            transform: 'translateX(-50%)',
            zIndex: -1,
            [theme.breakpoints.up('md')]: {
                height: 375
            },
        }
    },
    beerListingTheme: {
        ...theme.beerListingTheme,
    },
    icons: {
        alignSelf: 'center',
        paddingTop: '1.5em',
        paddingBottom: '1.5em',
    },
    masonry: {
        display: 'flex',
        marginLeft: -24,
        width: 'auto',
    },
    masonryColumn: {
        paddingLeft: 24,
        backgroundClip: 'padding-box',
        '& > div': {
            marginBottom: 24,
        }
    },
});